<template>
  <div class="ym-select" :class="{ 'is-header-mode': !!topLabel }" ref="wrapper" style="width: 200px;">
    <!-- Control principal (como un <select>) -->
    <div class="ym-select-control" @click="toggleOpen">
      <div v-if="topLabel" class="ym-select-stacked-content">
        <span class="ym-select-top-label">{{ topLabel }}</span>
        <span v-if="displayLabel" class="ym-select-bottom-label">{{ displayLabel }}</span>
        <span v-else class="ym-select-placeholder ym-select-bottom-label">{{ formatPeriod(period) }}</span>
      </div>
      <template v-else>
        <span v-if="displayLabel">{{ displayLabel }}</span>
        <span v-else class="ym-select-placeholder">{{ formatPeriod(period) }}</span>
      </template>

      <i class="fa" :class="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </div>

    <!-- Dropdown -->
    <div v-if="isOpen" class="ym-select-dropdown">
      <div class="ym-select-dropdown-inner">
        <div
          v-for="year in years"
          :key="year"
          class="ym-select-year-block"
        >
          <div class="ym-select-year-row">
            <div class="ym-select-year-main" @click="toggleYear(year)">
              <i class="fa" :class="isExpanded(year) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
              <span class="ym-select-year-label">{{ year }}</span>
            </div>

            <!-- Seleccionar TODO el año -->
            <button
              type="button"
              class="ym-select-year-all"
              @click.stop="selectYear(year)"
            >
              Año completo
            </button>
          </div>

          <!-- Meses del año -->
          <transition name="ym-collapse">
            <ul
              v-if="isExpanded(year)"
              class="ym-select-month-list"
            >
              <li
                v-for="month in getMonthsByYear(year)"
                :key="year + '-' + month.value"
                class="ym-select-month-item"
                :class="{ 'is-selected': isSelected(year, month.value) }"
                @click="selectMonth(year, month.value)"
              >
                {{ month.label }}
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "YearMonthSelect",
  props: {
    value: {
      type: String,
      default: ""
    },
    period: {
      type: String,
      default: ""
    },
    topLabel: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      isOpen: false,
      expandedYears: [],
      months: [
        { value: "12", label: "Diciembre" },
        { value: "11", label: "Noviembre" },
        { value: "10", label: "Octubre" },
        { value: "09", label: "Septiembre" },
        { value: "08", label: "Agosto" },
        { value: "07", label: "Julio" },
        { value: "06", label: "Junio" },
        { value: "05", label: "Mayo" },
        { value: "04", label: "Abril" },
        { value: "03", label: "Marzo" },
        { value: "02", label: "Febrero" },
        { value: "01", label: "Enero" },
      ]
    };
  },
  computed: {
    displayLabel() {
      if (!this.value) return "";

      const parts = this.value.split("-");
      const year = parts[0];
      const month = parts[1];

      if (!month) {
        return `${year} (año completo)`;
      }

      const monthObj = this.months.find(m => m.value === month);
      return monthObj ? `${monthObj.label} ${year}` : this.value;
    },
    years() {
        const year = new Date().getFullYear();
        return Array.from({ length: 5 }, (_, i) => year - i);
    },
    currentYear() {
      return new Date().getFullYear();
    },
    currentMonth() {
      return new Date().getMonth() + 1;
    }
  },
  methods: {
    getPreferredExpandedYear() {
      if (this.period) {
        const selectedYear = Number(String(this.period).split('-')[0]);
        if (!Number.isNaN(selectedYear)) {
          return selectedYear;
        }
      }

      if (this.value) {
        const selectedYear = Number(String(this.value).split('-')[0]);
        if (!Number.isNaN(selectedYear)) {
          return selectedYear;
        }
      }

      return this.currentYear;
    },
    ensureDefaultExpandedYear() {
      const year = this.getPreferredExpandedYear();
      if (!this.expandedYears.includes(year)) {
        this.expandedYears = [year];
      }
    },
    getMonthsByYear(year) {
      if (Number(year) !== this.currentYear) {
        return this.months;
      }

      return this.months.filter(month => Number(month.value) <= this.currentMonth);
    },
    toggleOpen() {
      const nextState = !this.isOpen;
      if (nextState) {
        this.ensureDefaultExpandedYear();
        this.$nextTick(() => {
          this.scrollSelectedIntoView();
        });
      }

      this.isOpen = nextState;
    },
    scrollSelectedIntoView() {
      if (!this.$refs.wrapper) return;

      const selectedMonth = this.$refs.wrapper.querySelector('.ym-select-month-item.is-selected');
      if (!selectedMonth) return;

      selectedMonth.scrollIntoView({ block: 'center' });
    },
    close() {
      this.isOpen = false;
    },
    isExpanded(year) {
      return this.expandedYears.includes(year);
    },
    toggleYear(year) {
      if (this.isExpanded(year)) {
        this.expandedYears = this.expandedYears.filter(y => y !== year);
      } else {
        this.expandedYears.push(year);
      }
    },
    selectYear(year) {
      const val = String(year);
      this.$emit("input", val);   // v-model
      this.$emit("change", val);  // opcional
      this.close();
    },
    selectMonth(year, monthValue) {
      const val = `${year}-${monthValue}`;
      this.$emit("input", val);   // v-model
      this.$emit("change", val);  // opcional
      this.close();
    },
    onClickOutside(e) {
      if (!this.$refs.wrapper) return;
      if (!this.$refs.wrapper.contains(e.target)) {
        this.close();
      }
    },
    isSelected(year, monthValue) {
        return this.period == `${year}-${monthValue}`
    },
    formatPeriod(period) {
        if (!period) return "";

        // Si es solo año
        if (/^\d{4}$/.test(period)) {
        return `${period} (año completo)`;
        }

        // Año y mes
        const [year, month] = period.split("-");

        const months = {
        "01": "Enero",
        "02": "Febrero",
        "03": "Marzo",
        "04": "Abril",
        "05": "Mayo",
        "06": "Junio",
        "07": "Julio",
        "08": "Agosto",
        "09": "Septiembre",
        "10": "Octubre",
        "11": "Noviembre",
        "12": "Diciembre",
        };

        return `${months[month]} ${year}`;
    }
  },
  mounted() {
    this.ensureDefaultExpandedYear();
    document.addEventListener("click", this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onClickOutside);
  }
};
</script>

<style scoped>
.ym-select {
  position: relative;
  width: 100%;
  max-width: 260px; /* ajústalo a tu layout */
  font-size: 12px;
  display: inline-block;   /* 🔥 clave */
  vertical-align: middle;  /* opcional para alinearlo con otros inputs */
}

/* Control principal */
.ym-select-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  border: 1px solid #7366FF;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.ym-select-control i {
  margin-left: 8px;
  font-size: 12px;
}

.ym-select-stacked-content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.ym-select-top-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.1;
  color: var(--theme-font-color, #2f2f2f);
  opacity: 0.75;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ym-select-bottom-label {
  display: block;
  font-size: 12px;
  line-height: 1.2;
  color: var(--theme-font-color, #2f2f2f);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ym-select-placeholder {
  color: #7366FF
}

/* Dropdown */
.ym-select-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 30;
  width: 100%;
  background: var(--white);
  border: 1px solid var(--sidebar-border);
  border-radius: 8px;
  box-shadow: 0 4px 12px var(--sidebar-border);
  overflow: hidden;
}

.ym-select-dropdown-inner {
  max-height: 280px;
  overflow-y: auto;
  padding: 8px;
}

/* Bloque de año */
.ym-select-year-block + .ym-select-year-block {
  border-top: 1px solid var(--sidebar-border);
  margin-top: 8px;
  padding-top: 8px;
}

.ym-select-year-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-radius: 6px;
  background: var(--sidebar-border);
}

/* Año (click para expandir/cerrar meses) */
.ym-select-year-main {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.ym-select-year-main i {
  margin-right: 6px;
  font-size: 11px;
  color: var(--theme-font-color);
  opacity: 0.75;
}

.ym-select-year-label {
  color: var(--theme-font-color);
  font-weight: 600;
}

/* Botón "año completo" */
.ym-select-year-all {
  border: 1px solid var(--sidebar-border);
  background: var(--white);
  color: var(--theme-font-color);
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
}

.ym-select-year-all:hover {
  background: var(--sidebar-border);
  color: var(--theme-deafult);
}

/* Meses */
.ym-select-month-list {
  list-style: none;
  margin: 0;
  padding: 6px 0 2px 0;
}

.ym-select-month-item {
  padding: 6px 10px;
  cursor: pointer;
  font-size: 12px;
  color: var(--theme-font-color);
  border-radius: 6px;
  transition: all 0.15s ease;
}

.ym-select-month-item:hover {
  background: var(--sidebar-border);
}

.ym-select-month-item.is-selected {
  background: var(--sidebar-border);
  color: var(--theme-deafult);
  font-weight: 600;
}

.ym-select.is-header-mode .ym-select-dropdown {
  border-color: var(--theme-deafult);
  box-shadow: 0 10px 24px var(--sidebar-border);
}

.ym-select.is-header-mode .ym-select-year-row {
  background: linear-gradient(120deg, var(--sidebar-border) 0%, var(--white) 100%);
  border: 1px solid var(--sidebar-border);
}

.ym-select.is-header-mode .ym-select-year-label {
  color: var(--theme-deafult);
}

.ym-select.is-header-mode .ym-select-year-all {
  border-color: var(--theme-deafult);
  color: var(--theme-deafult);
  background: var(--white);
}

.ym-select.is-header-mode .ym-select-year-all:hover {
  background: var(--theme-deafult);
  color: var(--white);
}

.ym-select.is-header-mode .ym-select-month-item:hover {
  background: var(--theme-secondary);
  color: var(--white);
}

.ym-select.is-header-mode .ym-select-month-item.is-selected {
  background: var(--theme-deafult);
  color: var(--white);
}

/* Animación de colapso simple */
.ym-collapse-enter-active,
.ym-collapse-leave-active {
  transition: all 0.15s ease;
}
.ym-collapse-enter,
.ym-collapse-leave-to {
  opacity: 0;
  transform: translateY(-3px);
}

/* Responsive básico */
@media (max-width: 576px) {
  .ym-select {
    max-width: 100%;
  }
}
</style>
